/**
 * `me` translations, for every locale -- the four self-service "Me" pages:
 * My salary, My info, My supervisor, My equipment.
 *
 * The four nav labels (`app.mySalary`, `app.myInfo`, `app.mySupervisor`,
 * `app.myEquipment`) and the band heading (`nav.groupMe`) live in shell.ts.
 */
export const me = {
  mn: {
    me: {
      settlementButton: 'Ээлжийн амралтын мөнгө авах хүсэлт',
      settlementLoading: 'Таны бүртгэл ачаалж байна',
      backlog: {
        title: 'Хүлээгдэж буй',
        scope: 'Хамрах хүрээ',
        timeCurrent: 'Цаг · одоогийн',
        timeOld: 'Цаг · хоцорсон',
        leave: 'Чөлөө',
        help: 'Одоогийн: цалингийн хаалт хараахан өнгөрөөгүй, батлагдаагүй өдрүүд. Хоцорсон: хаалтаас хойш батлагдаагүй өдрүүд. Чөлөө: шийдвэр хүлээж буй хүсэлтүүд.',
        timeError: 'Хүлээгдэж буй цагийн бүртгэлийн тоог ачаалж чадсангүй.',
      },
      timeBacklog: {
        mine: 'Өөрийн',
        supervisees: 'Харьяа ажилтан',
        everyone: 'Бүгд',
        loading: 'Ачаалж байна',
        listMine: 'Хаалтаас хойш хүлээгдэж буй миний өдрүүд: {{n}}',
        listSupervisees: 'Хаалтаас хойш хүлээгдэж буй хариуцсан ажилтнуудын өдрүүд: {{n}}',
        listError: 'Хаалтаас хойш хүлээгдэж буй өдрүүдийг ачаалж чадсангүй.',
      },
      overview: 'Миний тойм',
      toApprove: 'Батлах',
      sectionTime: 'Цаг',
      hoursTrend: 'Миний цаг, сүүлийн долоо хоногууд',
      othersZero: 'Бусад', moreRows: '+{{count}} бусад',
      overviewLoadError: 'Тоймыг ачаалж чадсангүй.',
      rosterMonth: 'Миний ээлжийн хуваарь, кодоор',
      rosterNoDays: 'Энэ сард ээлжийн өдөр алга.',
      rosterPlannedLabel: '{{label}} (төлөвлөсөн)',
      rosterDays_one: '{{count}} өдөр',
      rosterDays_other: '{{count}} өдөр',
      rosterMonthCaption: 'Хоёр кодтой өдөр хоёуланд нь тоологдоно. Төлөвлөсөн өдрийг тусад нь харуулав.',
      leaveYear: 'Чөлөөний үлдэгдэл, {{year}} он',
      leaveLoadFailed: 'Энэ оны чөлөөг ачаалж чадсангүй: {{detail}}. Хуудсыг дахин ачаална уу.',
      leaveUsed: 'Ашигласан',
      leaveRemaining: 'Үлдсэн',
      leaveUsageCaption: 'Ашигласан нь энэ онд эхэлсэн батлагдсан чөлөө; үлдсэн нь одоогийн үлдэгдэл.',
      leaveNone: 'Энэ онд чөлөөний үлдэгдэл, авсан чөлөө алга.',
      leaveBalanceUnknown: '{{code}}: энэ онд {{used}} хоног ашигласан; үлдэгдэл бүртгэлгүй.',
      leaveBalanceUnknownNoUsed: '{{code}}: үлдэгдэл бүртгэлгүй.',
      salaryHint: 'Зөвхөн таны олгогдсон цалингийн хуудас. Хугацаа сонгоход л ачаалагдана.',
      periodMonth: 'Нэг сар',
      periodRange: 'Хугацаа',
      month: 'Сар',
      from: 'Эхлэх',
      to: 'Дуусах',
      pickPeriod: 'Цалингийн хуудсаа харахын тулд сар эсвэл хугацаа сонгоно уу.',
      badRange: 'Эхлэх сар дуусах сараас хойш байна.',
      noneInPeriod: 'Энэ хугацаанд олгогдсон цалингийн хуудас алга.',
      payslipsLoadFailed: 'Таны цалингийн хуудсыг ачаалж чадсангүй.',
      payslipLoadFailed: 'Энэ цалингийн хуудсыг ачаалж чадсангүй.',
      pdfFailed: 'PDF татаж чадсангүй.',
      settlementFailed: 'Тооцооны хүсэлт илгээгдсэнгүй.',
      showAmounts: 'Дүнг харуулах',
      hideAmounts: 'Дүнг нуух',
      amountsHidden: 'Дүн нуугдсан байна. Цалингийн хуудсыг нээхийн тулд дүнг харуулна уу.',
      infoLoadFailed: 'Таны мэдээллийг ачаалж чадсангүй',
      infoHint: 'Хүний нөөцөд бүртгэлтэй таны мэдээлэл. Засах шаардлагатай бол хүний нөөцөд хандана уу.',
      noRecord: 'Хүний нөөцөд таны хувийн хэрэг хараахан үүсээгүй байна.',
      notRecorded: 'Бүртгэгдээгүй',
      sectionPersonal: 'Хувийн мэдээлэл',
      sectionContact: 'Холбоо барих',
      sectionEmployment: 'Ажил эрхлэлт',
      sectionEmergency: 'Яаралтай үед холбоо барих',
      field: {
        first_name: 'Нэр', last_name: 'Овог', first_name_mn: 'Нэр (монгол)', last_name_mn: 'Овог (монгол)',
        registration_no: 'Регистрийн дугаар',
        dob: 'Төрсөн огноо', gender: 'Хүйс', country: 'Улс', degree: 'Боловсрол', profession: 'Мэргэжил',
        email: 'Ажлын и-мэйл', personal_email: 'Хувийн и-мэйл', phone: 'Утас',
        staff_id: 'Ажилтны дугаар', staff_code: 'Ажилтны код', status: 'Төлөв', position: 'Албан тушаал',
        position_mn: 'Албан тушаал (монгол)', position_zh: 'Албан тушаал (хятад)', team: 'Баг',
        work_type: 'Ажлын төрөл', work_condition: 'Хөдөлмөрийн нөхцөл', office: 'Оффис',
        worked_since: 'Ажилд орсон', full_time_start: 'Бүтэн цагаар эхэлсэн', end_of_contract: 'Гэрээ дуусах',
        resignation_date: 'Ажлаас гарсан', trg_entity: 'Компани',
        dependent_children: 'Асрамжинд байгаа хүүхэд', notes: 'Тэмдэглэл',
        emergency_contact_name: 'Нэр', emergency_contact_phone: 'Утас',
      },
      teamHint: 'Таны шууд удирдлага болон танд шууд харьяалагддаг ажилтнууд.',
      yourSupervisor: 'Таны шууд удирдлага',
      yourReports: 'Танд харьяалагддаг ажилтнууд',
      noSupervisor: 'Танд шууд удирдлага бүртгэгдээгүй байна.',
      noReports: 'Танд шууд харьяалагддаг ажилтан алга.',
      position: 'Албан тушаал',
      email: 'И-мэйл',
      mobile: 'Гар утас',
      colleagueTitle: 'Ажилтны мэдээлэл',
      colleagueOpen: '{{name}}-ийн мэдээллийг нээх',
      reportSummary: {
        team: 'Баг', workMode: 'Өнөөдрийн горим', pendingLogs: 'Хүлээгдэж буй бүртгэл',
        pendingLeave: 'Хүлээгдэж буй чөлөө', monthHours: 'Энэ сарын цаг',
      },
      colleagueWork: 'Ажил',
      colleagueSupervisor: 'Шууд удирдлага',
      colleagueNotStarted: 'Ажил эхлээгүй',
      colleagueWithheld: 'Энэ хүний хувийн мэдээллийг харуулахгүй.',
      equipmentHint: 'Танд олгосон зөөврийн компьютерууд. Одоо байгаа нь эхэнд, дараа нь түүх.',
      current: 'Одоо танд байгаа',
      history: 'Өмнө нь',
      noCurrent: 'Одоогоор танд компьютер олгогдоогүй байна.',
      noHistory: 'Өмнөх бүртгэл алга.',
      assetTag: 'Хөрөнгийн дугаар',
      model: 'Загвар',
      received: 'Хүлээн авсан',
      returned: 'Буцаасан',
      status: 'Төлөв',
      accessories: 'Дагалдах хэрэгсэл',
      fund: {
        title: 'Үйл ажиллагааны сан',
        help: 'Сар бүр сандаа төлсөн шимтгэл. Төлсөн сар бүр оноо нэмж, жилийн эцсийн урамшууллыг тодорхойлно.',
        year: 'Он',
        summary: '{{due}} сараас {{paid}} төлсөн',
        total: 'Нийт',
        points: 'Оноо',
        paid: 'Төлсөн',
        unpaid: 'Төлөөгүй',
        not_due: 'Хугацаа болоогүй',
        unknown: 'Тодорхойгүй',
        loadFailed: 'Үйл ажиллагааны сангийн саруудыг ачаалж чадсангүй',
      },
      accessory: {
        mouse: 'Хулгана', flashdrive: 'Флаш диск', harddrive: 'Хатуу диск', converter: 'Хувиргагч', cooler_fan: 'Сэнс',
      },
    },
  },
  en: {
    me: {
      settlementButton: 'Request leave pay-out',
      settlementLoading: 'Your record is still loading',
      backlog: {
        title: 'Backlog',
        scope: 'Scope',
        timeCurrent: 'Time · current',
        timeOld: 'Time · old',
        leave: 'Leave',
        help: 'Current: unapproved days whose payroll cut-off has not passed. Old: days still unapproved after it. Leave: requests awaiting a decision.',
        timeError: 'Could not load the pending time-log counts.',
      },
      timeBacklog: {
        mine: 'Mine',
        supervisees: 'Supervisees',
        everyone: 'Everyone',
        loading: 'Loading',
        listMine: 'My days pending past the cut-off: {{n}}',
        listSupervisees: "Supervisees' days pending past the cut-off: {{n}}",
        listError: 'Could not load the days pending past the cut-off.',
      },
      overview: 'My overview',
      toApprove: 'To approve',
      sectionTime: 'Time',
      hoursTrend: 'My hours, recent weeks',
      othersZero: 'Others', moreRows: '+{{count}} more',
      overviewLoadError: 'Could not load your overview.',
      rosterMonth: 'My roster by code',
      rosterNoDays: 'No roster days this month.',
      rosterPlannedLabel: '{{label}} (planned)',
      rosterDays_one: '{{count}} day',
      rosterDays_other: '{{count}} days',
      rosterMonthCaption: 'A day with two codes counts under both. Planned days are shown apart.',
      leaveYear: 'Leave balance, {{year}}',
      leaveLoadFailed: 'Could not load your leave for this year: {{detail}}. Reload the page to try again.',
      leaveUsed: 'Used',
      leaveRemaining: 'Remaining',
      leaveUsageCaption: 'Used is approved leave starting this year; remaining is your current balance.',
      leaveNone: 'No leave balance or leave taken this year.',
      leaveBalanceUnknown: '{{code}}: {{used}} days used this year; remaining is not on record.',
      leaveBalanceUnknownNoUsed: '{{code}}: remaining is not on record.',
      salaryHint: 'Your own issued payslips only. Nothing loads until you pick a period.',
      periodMonth: 'One month',
      periodRange: 'Range',
      month: 'Month',
      from: 'From',
      to: 'To',
      pickPeriod: 'Pick a month or a range to see your payslips.',
      badRange: 'The start month is after the end month.',
      noneInPeriod: 'No payslip has been issued to you in this period.',
      payslipsLoadFailed: 'Your payslips could not be loaded.',
      payslipLoadFailed: 'This payslip could not be loaded.',
      pdfFailed: 'The PDF could not be downloaded.',
      settlementFailed: 'The settlement request was not sent.',
      showAmounts: 'Show amounts',
      hideAmounts: 'Hide amounts',
      amountsHidden: 'Amounts are hidden. Show them to open a payslip.',
      infoLoadFailed: 'Could not load your record',
      infoHint: 'Your record as HR holds it. If something is wrong, ask HR to correct it.',
      noRecord: 'HR has no personnel record for you yet.',
      notRecorded: 'Not recorded',
      sectionPersonal: 'Personal',
      sectionContact: 'Contact',
      sectionEmployment: 'Employment',
      sectionEmergency: 'Emergency contact',
      field: {
        first_name: 'First name', last_name: 'Last name', first_name_mn: 'First name (Mongolian)',
        registration_no: 'Registration no.',
        last_name_mn: 'Last name (Mongolian)', dob: 'Date of birth', gender: 'Gender', country: 'Country',
        degree: 'Degree', profession: 'Profession',
        email: 'Work email', personal_email: 'Personal email', phone: 'Phone',
        staff_id: 'Staff number', staff_code: 'Staff code', status: 'Status', position: 'Position',
        position_mn: 'Position (Mongolian)', position_zh: 'Position (Chinese)', team: 'Team',
        work_type: 'Work type', work_condition: 'Work condition', office: 'Office',
        worked_since: 'Worked since', full_time_start: 'Full-time since', end_of_contract: 'End of contract',
        resignation_date: 'Resignation date', trg_entity: 'Company',
        dependent_children: 'Dependent children', notes: 'Notes',
        emergency_contact_name: 'Name', emergency_contact_phone: 'Phone',
      },
      teamHint: 'Your direct supervisor, and the people who report directly to you.',
      yourSupervisor: 'Your supervisor',
      yourReports: 'Your direct reports',
      noSupervisor: 'No supervisor is recorded for you.',
      noReports: 'Nobody reports directly to you.',
      position: 'Position',
      email: 'Email',
      mobile: 'Mobile',
      colleagueTitle: 'Colleague',
      colleagueOpen: "Open {{name}}'s profile",
      reportSummary: {
        team: 'Team', workMode: 'Work mode today', pendingLogs: 'Pending logs',
        pendingLeave: 'Pending leave', monthHours: 'Hours this month',
      },
      colleagueWork: 'Work',
      colleagueSupervisor: 'Supervisor',
      colleagueNotStarted: 'Not started yet',
      colleagueWithheld: 'Personal details are not shown for this person.',
      equipmentHint: 'Laptops issued to you: what you hold now first, then the history.',
      current: 'With you now',
      history: 'History',
      noCurrent: 'No laptop is issued to you at the moment.',
      noHistory: 'No earlier hand-outs.',
      assetTag: 'Asset tag',
      model: 'Model',
      received: 'Received',
      returned: 'Returned',
      status: 'Status',
      accessories: 'Accessories',
      fund: {
        title: 'Activity fund',
        help: 'Your monthly contribution to the activity fund. Each paid month adds points toward the year-end activity bonus.',
        year: 'Year',
        summary: '{{paid}} of {{due}} months paid',
        total: 'Total',
        points: 'Points',
        paid: 'Paid',
        unpaid: 'Not paid',
        not_due: 'Not yet due',
        unknown: 'Unknown',
        loadFailed: 'Could not load your activity fund months',
      },
      accessory: {
        mouse: 'Mouse', flashdrive: 'Flash drive', harddrive: 'Hard drive', converter: 'Converter', cooler_fan: 'Cooler fan',
      },
    },
  },
  ru: {
    me: {
      settlementButton: 'Подать заявку на выплату за отпуск',
      settlementLoading: 'Ваша запись ещё загружается',
      backlog: {
        title: 'Ожидают решения',
        scope: 'Охват',
        timeCurrent: 'Время · текущие',
        timeOld: 'Время · старые',
        leave: 'Отпуск',
        help: 'Текущие: неутверждённые дни, отсечка зарплаты по которым ещё не прошла. Старые: дни, не утверждённые после неё. Отпуск: заявки, ожидающие решения.',
        timeError: 'Не удалось загрузить число неутверждённых дней учёта времени.',
      },
      timeBacklog: {
        mine: 'Мои',
        supervisees: 'Подчинённые',
        everyone: 'Все',
        loading: 'Загрузка',
        listMine: 'Мои дни, ожидающие после отсечки: {{n}}',
        listSupervisees: 'Дни подчинённых, ожидающие после отсечки: {{n}}',
        listError: 'Не удалось загрузить дни, ожидающие после отсечки.',
      },
      overview: 'Мой обзор',
      toApprove: 'На утверждение',
      sectionTime: 'Время',
      hoursTrend: 'Мои часы за последние недели',
      othersZero: 'Прочие', moreRows: 'ещё {{count}}',
      overviewLoadError: 'Не удалось загрузить обзор.',
      rosterMonth: 'Мой график по кодам',
      rosterNoDays: 'В этом месяце нет дней в графике.',
      rosterPlannedLabel: '{{label}} (план)',
      rosterDays_one: '{{count}} день',
      rosterDays_few: '{{count}} дня',
      rosterDays_many: '{{count}} дней',
      rosterDays_other: '{{count}} дня',
      rosterMonthCaption: 'День с двумя кодами учитывается в обоих. Плановые дни показаны отдельно.',
      leaveYear: 'Остаток отпуска, {{year}} год',
      leaveLoadFailed: 'Не удалось загрузить отпуск за этот год: {{detail}}. Перезагрузите страницу.',
      leaveUsed: 'Использовано',
      leaveRemaining: 'Осталось',
      leaveUsageCaption: 'Использовано — одобренный отпуск, начавшийся в этом году; осталось — текущий остаток.',
      leaveNone: 'В этом году нет остатка отпуска и взятого отпуска.',
      leaveBalanceUnknown: '{{code}}: в этом году использовано дней: {{used}}; остаток не записан.',
      leaveBalanceUnknownNoUsed: '{{code}}: остаток не записан.',
      salaryHint: 'Только ваши выданные расчётные листки. Ничего не загружается, пока вы не выберете период.',
      periodMonth: 'Один месяц',
      periodRange: 'Период',
      month: 'Месяц',
      from: 'С',
      to: 'По',
      pickPeriod: 'Выберите месяц или период, чтобы увидеть расчётные листки.',
      badRange: 'Начальный месяц позже конечного.',
      noneInPeriod: 'За этот период расчётные листки вам не выдавались.',
      payslipsLoadFailed: 'Не удалось загрузить ваши расчётные листки.',
      payslipLoadFailed: 'Не удалось загрузить этот расчётный листок.',
      pdfFailed: 'Не удалось скачать PDF.',
      settlementFailed: 'Заявка на расчёт не отправлена.',
      showAmounts: 'Показать суммы',
      hideAmounts: 'Скрыть суммы',
      amountsHidden: 'Суммы скрыты. Покажите их, чтобы открыть расчётный листок.',
      infoLoadFailed: 'Не удалось загрузить вашу запись',
      infoHint: 'Ваши данные в отделе кадров. Если что-то неверно, обратитесь в отдел кадров.',
      noRecord: 'В отделе кадров пока нет вашей личной карточки.',
      notRecorded: 'Не указано',
      sectionPersonal: 'Личные данные',
      sectionContact: 'Контакты',
      sectionEmployment: 'Работа',
      sectionEmergency: 'Экстренный контакт',
      field: {
        first_name: 'Имя', last_name: 'Фамилия', first_name_mn: 'Имя (монг.)', last_name_mn: 'Фамилия (монг.)',
        registration_no: 'Регистрационный номер',
        dob: 'Дата рождения', gender: 'Пол', country: 'Страна', degree: 'Образование', profession: 'Профессия',
        email: 'Рабочая почта', personal_email: 'Личная почта', phone: 'Телефон',
        staff_id: 'Табельный номер', staff_code: 'Код сотрудника', status: 'Статус', position: 'Должность',
        position_mn: 'Должность (монг.)', position_zh: 'Должность (кит.)', team: 'Команда',
        work_type: 'Тип занятости', work_condition: 'Условия труда', office: 'Офис',
        worked_since: 'Работает с', full_time_start: 'Полная ставка с', end_of_contract: 'Окончание договора',
        resignation_date: 'Дата увольнения', trg_entity: 'Компания',
        dependent_children: 'Дети на иждивении', notes: 'Примечания',
        emergency_contact_name: 'Имя', emergency_contact_phone: 'Телефон',
      },
      teamHint: 'Ваш непосредственный руководитель и ваши прямые подчинённые.',
      yourSupervisor: 'Ваш руководитель',
      yourReports: 'Ваши подчинённые',
      noSupervisor: 'Руководитель для вас не указан.',
      noReports: 'У вас нет прямых подчинённых.',
      position: 'Должность',
      email: 'Эл. почта',
      mobile: 'Мобильный',
      colleagueTitle: 'Сотрудник',
      colleagueOpen: 'Открыть профиль: {{name}}',
      reportSummary: {
        team: 'Команда', workMode: 'Режим сегодня', pendingLogs: 'Табели на рассмотрении',
        pendingLeave: 'Отпуска на рассмотрении', monthHours: 'Часы за месяц',
      },
      colleagueWork: 'Работа',
      colleagueSupervisor: 'Руководитель',
      colleagueNotStarted: 'Ещё не приступил к работе',
      colleagueWithheld: 'Личные данные этого человека не показываются.',
      equipmentHint: 'Выданные вам ноутбуки: сначала текущий, затем история.',
      current: 'Сейчас у вас',
      history: 'История',
      noCurrent: 'Сейчас вам не выдан ноутбук.',
      noHistory: 'Предыдущих выдач нет.',
      assetTag: 'Инв. номер',
      model: 'Модель',
      received: 'Получен',
      returned: 'Возвращён',
      status: 'Статус',
      accessories: 'Комплект',
      fund: {
        title: 'Фонд мероприятий',
        help: 'Ваш ежемесячный взнос в фонд мероприятий. Каждый оплаченный месяц добавляет баллы к годовому бонусу.',
        year: 'Год',
        summary: 'Оплачено {{paid}} из {{due}} мес.',
        total: 'Итого',
        points: 'Баллы',
        paid: 'Оплачено',
        unpaid: 'Не оплачено',
        not_due: 'Срок не наступил',
        unknown: 'Неизвестно',
        loadFailed: 'Не удалось загрузить месяцы фонда мероприятий',
      },
      accessory: {
        mouse: 'Мышь', flashdrive: 'Флешка', harddrive: 'Жёсткий диск', converter: 'Переходник', cooler_fan: 'Подставка с вентилятором',
      },
    },
  },
}
